import Client from "@/app/Http/Client";
import HasProperties from "../models/Concerns/HasProperties";

export default class StorageAttachment extends HasProperties {
    public filename!: string;
    public extension!: string;
    public url!: string;

    public async destroy(): Promise<boolean> {
        await Client.delete(this.url.replace('/storage/', '/file-storage/'));

        return true;
    }
}